import uiReducer from "./reducers";

export default uiReducer;
